import React, { useState } from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const CardKeyWrapper = styled.div``;

const PurchaseKeyRow = styled.div`
  display: flex;
  grid-gap: 0 11px;
  margin-bottom: 4px;
  margin-top: 8px;
  cursor: pointer;
  align-items: center;
  .key-icon-container {
    height: 46px;
    width: 46px;
    background: #e3e7f2;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      height: 28px !important;
      width: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    div {
      height: 28px !important;
      width: 28px !important;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
  }
  .key-content {
    max-width: 65%;
    .license-key-title {
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      color: #9da3b7;
    }
    .license-key-body {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
      margin-top: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

const KeyCopyIcon = styled.div<{ isCopied: boolean }>`
  position: relative;
  height: 46px;
  width: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isCopied ? '#23E588aa' : '#e3e7f2')};
  border-radius: 12px;
  img {
    height: 24px !important;
    width: 24px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    position: relative !important;
    cursor: pointer;
  }
  div {
    height: 24px !important;
    width: 24px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    position: relative !important;
    cursor: pointer;
  }
`;

interface CardKeyProps {
  email: string;
  listingKey: string;
  password: string;
  secondaryKey: string;
  type: number;
  authType: string;
  dataTour?: string;
  botId?: string;
  buyerEmail?: string;
}

const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const CardKey = (props: CardKeyProps): JSX.Element => {
  if (
    (!props.email &&
      !props.listingKey &&
      !props.secondaryKey &&
      !props.password) ||
    props.type != 0
  ) {
    return (
      <CardKeyWrapper data-tour={props.dataTour}>
        {(props.authType === '1key' || props.authType === '2key') && (
          <CopyRow value="XXXX-XXXX-XXXX-XXXX" label="Key" />
        )}
        {props.authType === '2key' && (
          <CopyRow value="XXXX-XXXX-XXXX-XXXX" label="Secondary Key" />
        )}
        {props.authType === 'login' && (
          <CopyRow value="XXXX@XXXXXXXX" label="Email" />
        )}
        {props.authType === 'login' && (
          <CopyRow value="XXXXXXXX" label="Password" />
        )}
      </CardKeyWrapper>
    );
  }

  // was used before direct listing
  // if (props.botId === 'cybersole' && props.buyerEmail) {
  //   return (
  //     <CopyRow value={props.buyerEmail} label="Check email" />
  //   );
  // }

  return (
    <CardKeyWrapper>
      {props.email && <CopyRow value={props.email} label="Email" />}
      {props.password && <CopyRow value={props.password} label="Password" />}
      {props.listingKey && <CopyRow value={props.listingKey} label="Key" />}
      {props.secondaryKey && (
        <CopyRow value={props.listingKey} label="Secondary Key" />
      )}
    </CardKeyWrapper>
  );
};

const CopyRow = (props: { value: string; label: string }) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  return (
    <CopyToClipboard
      text={props.value}
      onCopy={async () => {
        setIsCopied(true);
        await sleep(2500);
        setIsCopied(false);
      }}
    >
      <PurchaseKeyRow>
        <div className="key-icon-container">
          <div>
            <Image alt="" src={'/images/new/key.svg'} layout="fill" />
          </div>
        </div>
        <div className="key-content w-full">
          <p className="license-key-title">{props.label}</p>
          <p className="license-key-body ">
            {(props.value || 'XXXX-XXXX-XXXX-XXXX').substring(0, 20)}...
          </p>
        </div>
        <KeyCopyIcon isCopied={isCopied}>
          <Image
            alt={`Copy ${props.label}`}
            src={isCopied ? '/images/new/tick.svg' : '/images/new/copy.svg'}
            layout="fill"
          />
        </KeyCopyIcon>
      </PurchaseKeyRow>
    </CopyToClipboard>
  );
};

export default CardKey;
